import React, { useState } from "react";
import styles from "./Pricing.module.css";

import SimpleBtn from "../../../components/Button/SimpleBtn";
import { FontAwesomeIcon as Ficon } from "@fortawesome/react-fontawesome";
import {
  faJetFighter,
  faCar,
  faBicycle,
  faRocket,
  faCircleCheck,
} from "@fortawesome/free-solid-svg-icons";
import { handleCall } from "../../../utils/callHelper";

function Pricing() {
  const [hover, setHover] = useState();

  const pricing = [
    {
      title: "سرویس پایه",
      require: "راه اندازی بر روی سرور راهیاب",
      icon: faBicycle,
      type: "اشتراک هر خودرو (سالانه)",
      price: "مشاوره فروش",
      backgroundColor: "#255025",
      color: "white",
      details: [
        "مدیریت ناوگان و موقعیت‌یابی لحظه‌ای",
        "گزارش دقیق مسیرهای پیموده‌شده",
        "ردیابی توقف‌های طولانی و غیرمجاز",
        "هشدار سرعت غیرمجاز و تخلفات رانندگی",
        "مدیریت و کنترل محدوده‌های جغرافیایی",
        "اعلان‌های هوشمند برای سرویس‌های دوره‌ای",
        "سیستم پیشرفته تعمیر و نگهداری خودرو",
        "مدیریت هزینه‌ها و بهینه‌سازی مصرف سوخت",
        "اشتراک‌گذاری دسترسی به خودروها با کاربران مجاز",
        "ارسال هشدارهای مهم از طریق پیامک و ایمیل",
        "نظارت بر مصرف سوخت و الگوی رانندگی",
        "مدیریت حساب‌های کاربری و سطح دسترسی‌ها",
      ],
    },
    {
      title: "سرویس پیشرفته",
      require: "راه اندازی بر روی سرور راهیاب",
      icon: faCar,
      type: "اشتراک هر خودرو (سالانه)",
      price: "مشاوره فروش",
      backgroundColor: "rgb(49 81 105)",
      color: "white",
      details: [
        "پکیج کامل خدمات پایه و پیشرفته",
        "سامانه هوشمند تحلیل و ارزیابی رفتار راننده",
        "مدیریت ماموریت‌های حمل و نقل و مسیرچینی هوشمند",
        "اپلیکیشن اختصاصی راننده برای پایش و گزارش‌گیری",
        "اپلیکیشن ویژه تکنسین‌های نگهداری و تعمیرات خودرو",
        "نظارت و مدیریت دوربین‌های امنیتی و کابین خودرو",
        "دیاگ آنلاین و عیب‌یابی هوشمند خودرو",
        "مدیریت رویدادها، تخلفات و وقایع حیاتی ناوگان",
        "کنترل و نظارت پیشرفته بر انبارها و محموله‌ها",
        "سیستم هوشمند پخش و توزیع بار",
        "یکپارچگی با سیستم‌های مالی، اداری و لجستیکی",
        "مدیریت و صدور بارنامه دیجیتال با قابلیت رهگیری",
        "سیستم تحلیل و بهینه‌سازی مصرف سوخت و هزینه‌ها",
        "کنترل و بهینه‌سازی فرآیندهای حمل‌ونقل درون‌شهری و برون‌شهری",
      ],
    },
    {
      title: "سرویس اختصاصی",
      require: "راه اندازی بر روی سرور مشتری",
      icon: faJetFighter,
      type: "اشتراک هر خودرو (سالانه)",
      price: "مشاوره فروش",
      backgroundColor: "rgb(77 28 82)",
      color: "white",
      details: [
        "پکیج کامل خدمات پایه و پیشرفته",
        "تحلیل هوشمند رفتار راننده و ارزیابی عملکرد",
        "اپلیکیشن راننده برای مدیریت مسیر و ماموریت‌ها",
        "اپلیکیشن تکنسین جهت نگهداری و تعمیرات خودرو",
        "نظارت پیشرفته بر دوربین‌های امنیتی و داخل کابین",
        "دیاگ آنلاین و عیب‌یابی هوشمند خودرو",
        "مدیریت وقایع، هشدارها و تخلفات رانندگی",
        "سیستم هوشمند پخش و توزیع بار",
        "مسیرچینی و برنامه‌ریزی ماموریت‌های حمل و نقل",
        "مدیریت بارنامه دیجیتال و رهگیری لحظه‌ای محموله",
        "کنترل و بهینه‌سازی فرآیندهای انبارداری",
        "یکپارچگی با سیستم‌های مالی، اداری و لجستیکی",
        "بهینه‌سازی مصرف سوخت و مدیریت هزینه‌ها",
      ],
    },
    // {
    //   title: "ساخت/فروش نرم‌افزار",
    //   require: "نیاز سازمانی و امنیتی",
    //   icon: faRocket,
    //   type: "",
    //   price: "مشاوره فروش",
    //   backgroundColor: "#d8b600",
    //   color: "white",
    //   details: [
    //     "تمامی خدمات پکیج پایه",
    //     "سامانه هوشمند تحلیل رفتار راننده",
    //     "اپلیکیشن راننده",
    //     "اپلیکیشن تکنسین نگهداری خودرو",
    //     "مدیریت وقایع و رویدادها",
    //     "مدیریت دوربین(های) نظارتی خودرو",
    //     "دیاگ آنلاین",
    //     "مدیریت محصولات",
    //     "سیستم پخش هوشمند",
    //     "مسیرچینی هوشمند",
    //     "مدیریت ماموریت حمل و نقل",
    //     "مدیریت رویدادها",
    //     "مدیریت و صدور بارنامه",
    //     "مدیریت انبارها",
    //     "ارتباط با سیستم های مالی و اداری",
    //   ],
    // },
  ];
  return (
    <section
      id="homePage-pricing__sec"
      className={`${styles.pricingCont} pricing__cont`}>
      <div className={`${styles.pricing} `}>
        <h1 className={`${styles.pricingTitle} `}>تعرفه‌های راهیاب</h1>
        {pricing.map((e, index) => {
          return (
            <div
              key={index}
              className={`${styles.priceCont}`}
              onMouseEnter={() => setHover(index)}
              onMouseLeave={() => setHover(undefined)}
              style={{
                boxShadow: hover == index && `0 0 10px 0 ${e.backgroundColor}`,
              }}>
              <div className={`${styles.priceHead}`}>
                <div className={`${styles.priceTitr}`}>
                  {" "}
                  <h3 className={`${styles.priceTitle}`}>{e.title}</h3>
                  <span className={`${styles.priceRequire}`}>{e.require}</span>
                </div>
                <div
                  className={`${styles.priceAvatar}`}
                  style={{ color: e.backgroundColor }}>
                  <Ficon className={`${styles.priceIcon}`} icon={e.icon} />
                </div>
                <div className={`${styles.price}`}>
                  <span>{e.type}</span>
                  <SimpleBtn
                    style={{
                      backgroundColor: e.backgroundColor,
                      color: "white",
                      padding: "0 .5rem",
                      boxShadow: "0 5px 5px -4px black",
                    }}
                    onClick={handleCall}>
                    {e.price}
                  </SimpleBtn>
                </div>
              </div>

              <div
                className={`${styles.priceBody}`}
                style={{ backgroundColor: e.backgroundColor, color: e.color }}>
                <span className={`${styles.priceBodyTitle}`}></span>
                <ul>
                  {e.details.map((j, index) => {
                    return (
                      <li key={index}>
                        <Ficon
                          icon={faCircleCheck}
                          style={{ paddingLeft: ".5rem" }}
                        />
                        {j}
                      </li>
                    );
                  })}
                  {e.title != "سرویس پایه" && (
                    <li>
                      <Ficon
                        icon={faCircleCheck}
                        style={{ paddingLeft: ".5rem" }}
                      />
                      و...
                    </li>
                  )}
                </ul>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}

export default Pricing;
